export const SITE_MEMBERS_BM_URL = 'member-permissions/members';
export const SITE_MEMBERS_ACCESS_BM_URL = 'site-members/access';
export const BADGES_BM_URL = 'badge-definitions';
export const MEMBERS_ACCOUNT_BM_URL = 'members-account';
export const SEO_REDIRECT = '/seo-home/redirects';
